<template>
  <v-container grid-list-xs>
    <v-layout column>
      <v-flex class="mb-5">
        <h1>{{ story.data.title }}</h1>
        {{ story.data.content }}
      </v-flex>
      <v-flex class="mb-5">Author: {{ story.data.signature}}</v-flex>
      <v-divider class="mb-5"></v-divider>
      <v-flex xs6>
        <v-flex>
          <v-btn
            class="ma-5"
            color="primary"
            v-if="!story.data.markAsRead"
            @click="read()">
            Mark as read
          </v-btn>
        </v-flex>
        <v-flex xs6>
          <v-btn
            class="ma-5"
            :depressed="true"
            color="error"
            @click="removeStory()">
            Delete
          </v-btn>
        </v-flex>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    props: {
      story: Object
    },
    data(){
      return{
      }
    },
    methods: {
      ...mapActions({
        markAsRead: 'markAsRead',
        deleteStory: 'deleteStory'
      }),
      read () {
        this.markAsRead(this.story.id);
      },
      removeStory () {
        this.deleteStory(this.story.id);
      }
    }
  }
</script>
